<template >
  <div class="left-bar">
    <el-col>
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo el-scrollbar-wrap"
        :unique-opened="true"
        router
      >
        <el-scrollbar wrap-class="list" :native="false">
          <!-- 二级菜单循环 -->
          <div v-for="(item, i) in NewMenu" :key="i">
            <!-- 无子菜单 -->
            <el-menu-item :index="item.url" v-if="item.children.length === 0">
              <img :src="item.imgURL" class="icon" />
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
            <!-- 有子菜单 -->
            <el-submenu :index="i + ''" v-if="item.children.length !== 0">
              <template slot="title">
                <img :src="item.imgURL" class="icon" />
                <span>{{ item.name }}</span>
              </template>

              <!-- 三级菜单 -->
              <div v-for="(sub, j) in item.children" :key="j">
                <!-- 无子菜单的 -->
                <el-menu-item :index="sub.url" v-if="sub.children.length === 0">
                  <span slot="title">{{ sub.name }}</span>
                </el-menu-item>

                <!-- 有子菜单的 -->
                <el-submenu
                  :index="i + '-' + j"
                  v-if="sub.children.length !== 0"
                >
                  <template slot="title">
                    <span>{{ sub.name }}</span>
                  </template>
                  <el-menu-item
                    :index="sub3.url"
                    v-for="(sub3, k) in sub.children"
                    :key="i + '-' + j + '-' + k"
                    :class="{ colorred: sub.color === 'red' }"
                    >{{ sub3.name }}</el-menu-item
                  >
                </el-submenu>
              </div>
            </el-submenu>
          </div>
        </el-scrollbar>
      </el-menu>
    </el-col>
  </div>
</template>

<script>
// import { permissionTel } from '@/config.js'
import { mapGetters } from 'vuex'
import { getMenu } from '@/apis/permission.js'
import { isGY } from '@/utils/api'
import { newMenu2, newMenu3 } from './menu.js'
export default {
  name: 'LeftBar',
  data() {
    return {
      menu: [],
      NewMenu: []
    }
  },
  async created() {
    try {
      let res = await getMenu(this.userInfo.userID)
      this.menu = res
      let menu1 = this.menu.filter((item) => item.level === 1 && item.type === 0)
      let menu2 = this.menu.filter((item) => item.level === 2 && item.type === 0)
      let menu3 = this.menu.filter((item) => item.level === 3 && item.type === 0)
      // let accoutShow=this.menu.filter(item => item.name === '结算权限' && item.type===1)
      //this.$store.commit('SET_ACCOUNT',accoutShow.length>0) //结算是否显示
      // menu2 = newMenu2
      //   .slice(0, newMenu2.length - 1)
      //   .concat(menu2)
      //   .concat(newMenu2.slice(newMenu2.length - 1))
      menu2 = newMenu2.concat(menu2)
      menu3 = menu3.concat(newMenu3)
      if (isGY) menu2 = menu2.filter((item) => item.id !== 399 && item.id !== 99999) // 美团活动信息 和 版本控制
      // 老怪兽菜单接口模拟
      menu1.forEach((item) => {
        // 一级目录 6 商品管理
        item.children = []
        menu2.forEach((it2) => {
          it2.children = []
          if (item.id === it2.parentID) {
            item.children.push(it2)
          }
          menu3.forEach((it3) => {
            if (it2.id === it3.parentID) {
              it2.children.push(it3)
            }
          })
        })
      })
      // menu1[4].children = menu1[4].children.slice(1,menu1[4].children.length-1)
      //   .concat(menu1[4].children.slice(0,1))
      //   .concat(menu1[4].children.slice(menu1[4].children.length-1))
      menu1[4].children = menu1[4].children.slice(2,menu1[4].children.length-1)
        .concat(menu1[4].children.slice(0,2))
        .concat(menu1[4].children.slice(menu1[4].children.length-1))
      this.NewMenu = menu1
    } catch (error) {}
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      yunyingMap: 'yunyingMap'
    })
  },
  methods: {
    // 交换变量
    swapArrayElements(arr, indexA, indexB) {
        
    },
    // 点击相同router-link 刷新组件
    clickLink(path) {
      // this.$root.reload()
      // this.$emit('reload')
      this.$store.dispatch('RefreshPage', false)
      this.$nextTick(() => {
        this.$store.dispatch('RefreshPage', true)
      })
      // this.$router.push({
      //   path,
      //   query: {
      //     t: +new Date() // 保证每次点击路由的query项都是不一样的，确保会重新刷新view
      //   }
      // })
    }
  }
}
</script>

<style lang="scss">
.left-bar {
  .el-col {
    // width: 50px;
    // overflow: hidden;
    height: calc(100vh - 63px);
  }
  .icon {
    width: 16px;
    margin-right: 10px;
  }
  .el-scrollbar-wrap {
    width: 230px;
    height: 100%;
    overflow: hidden;
    // margin-top: 1px;
  }
  .el-menu-item-group {
    .el-menu-item {
      line-height: 1.2;
      padding: 10px 10px;
      padding-left: 10px !important;
      margin-left: 30px;
      border-left: 1px solid #e4e7ed;
      height: auto;
      white-space: normal;
      &:hover {
        background: none;
        color: #1989fa;
      }
      &:focus {
        background: none;
        color: #1989fa;
      }
    }
    .is-active {
      // font-weight: bold;
      border-left: 3px solid #1989fa;
      color: #1989fa;
    }
  }
  // 高亮文字
  .highlight {
    // color: #409EFF;
    vertical-align: inherit;
  }
  // 滚动区域高度，超过这个高度，出现滚动条
  .list {
    max-height: calc(100vh - 63px);
  }
  // 滚动条颜色
  .el-scrollbar__thumb {
    background: #ccc;
  }
  .colorred {
    color: #f56c6c;
    &:hover {
      color: red !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu/leftbarnew.vue